module.exports = __webpack_public_path__ + "img/1524741254.01a82063.jpg";